import { Slider, SliderSingleProps, Spin, notification } from "antd";
import requestService from "api/request";
import clsx from "clsx";
import { formatNumber } from "lib/helpers/format";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store";
import { onSetUser } from "store/app";
import { Swiper, SwiperSlide } from "swiper/react";

interface Props {
  token?: any;
}
const SwapCoinFutrue = ({ token }: Props) => {
  const { user, appGlobal } = useAppSelector((state) => state.app) as any;
  const [packageId, setPackageId] = useState<any>("");
  const [isTypeSwap, setIsTypeSwap] = useState<string>("buy");
  const [is_open_trade, set_is_open_trade] = useState<"market" | "limit">(
    "limit"
  );
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [openPrice, setOpenPrice] = useState(token?.quote?.USD?.price);

  useEffect(() => {
    if (token) setOpenPrice(token?.quote?.USD?.price);
  }, [token]);

  const currentToken = user?.tokens?.find((i: any) => i?.tokenId === token?.id);

  const [formData, setFormData] = useState<number>(0);

  // const handleSwapToken = () => {
  //   if (isTypeSwap === "buy") return handleBuyToken();
  //   else return handleSellToken();
  // };

  const handleChangeSlider = (value: any) => {
    const valueUsdt = user?.real_balance * (value / 100);
    setFormData(valueUsdt);
    // if (isTypeSwap === "buy") {
    //   const valueUsdt = user?.real_balance * (value / 100);
    //   setFormData({
    //     amount: valueUsdt / (token?.quote?.USD?.price || 1),
    //     value: valueUsdt,
    //   });
    // }
    // if (isTypeSwap === "sell") {
    //   const amountToken = currentToken?.amount * (value / 100);
    //   setFormData({
    //     amount: amountToken,
    //     value: amountToken * (token?.quote?.USD?.price || 1),
    //   });
    //}
  };
  const handleBuyToken = async () => {
    if (!formData)
      return notification.error({
        message: "Số tiền đặt không đúng",
        duration: 5,
      });
    if (!packageId)
      return notification.error({ message: "Bạn chưa chọn gói", duration: 5 });
    setLoading(true);
    try {
      const res = await requestService.post("/trading/buy-package", {
        data: {
          symbol: token?.symbol,
          value: formData,
          tokenId: token?.id,
          open_price: openPrice,
          bet_condition: isTypeSwap,
          packageId,
        },
      });
      if (res && res.data) {
        dispatch(onSetUser(res?.data?.data));
        notification.success({
          message: "Trading Success",
          duration: 5,
        });
        setFormData(0);
      }
    } catch (error: any) {
      notification.error({
        message: error?.response?.data?.message,
        duration: 5,
      });
    }
    setLoading(false);
  };

  const marks: SliderSingleProps["marks"] = {
    0: "0%",
    25: "25%",
    50: "50%",
    75: "75%",
    100: "100%",
  };

  return (
    <div className="z4ZsPFgg7hqlEN3efa4_">
      <Spin fullscreen spinning={loading} />
      <div className="dryxLdVtYO96FMiId6kh">
        <div className="mt-[12px] mb-[12px] flex justify-center gap-10 relative h-[38px] leading-[38px] text-contentAlwaysWhite select-none">
          <div
            className={clsx(
              " flex-auto w-1/2 ps-8 relative text-center rounded-full cursor-pointer z-10 after:-z-10 after:w-1/2 after:content-[''] after:bg-inherit after:h-full after:rounded-r-lg after:absolute after:top-0 after:-right-4 after:-skew-x-[35deg]",
              {
                "bg-contentTradeBuy": isTypeSwap === "buy",
                "bg-backgroundTertiary": isTypeSwap === "sell",
              }
            )}
            onClick={() => setIsTypeSwap("buy")}
          >
            {t("Mua")}
          </div>
          <div
            className={clsx(
              "bg-backgroundTertiary text-contentPrimary flex-auto w-1/2 pe-8 relative overflow-visible text-center rounded-full cursor-pointer z-10 before:-z-10 before:w-1/2 before:content-[''] before:bg-inherit before:h-full before:rounded-l-lg before:absolute before:top-0 before:-left-4 before:skew-x-[-35deg]",
              {
                "bg-contentTradeSell": isTypeSwap === "sell",
                "bg-backgroundTertiary": isTypeSwap === "buy",
              }
            )}
            onClick={() => setIsTypeSwap("sell")}
          >
            {t("Bán")}
          </div>
        </div>
        <div className="tab-spot-box">
          <div className="WuGXUls86JxveXC3DnMI first:mr-48px">
            <div className="can-use mb-[12px]">
              <div className="yLEkaktx3qeyfzsFDwQG">
                <div className="hr7hPBtwQG5YhCXFLrNf">
                  <div>
                    {/* {isTypeSwap === "buy" ? (
                 
                    ) : (
                      <span className="Uir5Os0doecSnU6ViYnz">
                        {t("Khả dụng")}{" "}
                        {user ? formatNumber(currentToken?.amount) : "--"}{" "}
                        {token?.symbol}
                      </span>
                    )} */}
                    <span className="Uir5Os0doecSnU6ViYnz">
                      {t("Khả dụng")}{" "}
                      {user
                        ? formatNumber(user?.real_balance?.toFixed(4))
                        : "--"}{" "}
                      USDT
                    </span>
                  </div>
                  <div className="RjXquEXTclGvowtIY1VA">
                    <Link to="/deposit">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                        className="w-[20px] h-[20px] cursor-pointer LQ0SY86vPLw0EJmAtKlQ"
                      >
                        <path d="M20.4 12a8.4 8.4 0 10-16.8 0 8.4 8.4 0 0016.8 0zm1.6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM12 8a.8.8 0 01.8.8v2.4h2.4a.8.8 0 010 1.6h-2.4v2.4a.8.8 0 01-1.6 0v-2.4H8.8a.8.8 0 010-1.6h2.4V8.8A.8.8 0 0112 8z" />
                      </svg>
                    </Link>
                    <Link to="/trading">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                        className="w-[20px] h-[20px] mt-[2px] cursor-pointer ms-[8px] LQ0SY86vPLw0EJmAtKlQ"
                      >
                        <path d="M11.4 1.8a9.464 9.464 0 018.029 4.467l.192.309a9.123 9.123 0 010 9.648l-.192.309A9.463 9.463 0 0111.4 21a9.465 9.465 0 01-8.028-4.467l-.192-.309a9.124 9.124 0 010-9.648l.192-.309A9.464 9.464 0 0111.4 1.8zm0 1.557a7.92 7.92 0 00-6.717 3.738l-.192.308a7.559 7.559 0 000 7.994l.192.309a7.92 7.92 0 006.718 3.737 7.92 7.92 0 006.718-3.738l.192-.308a7.558 7.558 0 000-7.994l-.192-.308A7.92 7.92 0 0011.4 3.357zm3.363 8.79c.427 0 .773.349.773.779a.777.777 0 01-.699.775l-.074.003H9.177l.875 1.43a.781.781 0 01-.192 1.03l-.061.042a.77.77 0 01-1.023-.193l-.042-.063-1.602-2.616a.78.78 0 01.593-1.184l.066-.002h6.972zm-.986-4.85l.042.063 1.602 2.616a.78.78 0 01-.593 1.184l-.066.003H7.79a.776.776 0 01-.773-.779c0-.404.306-.736.699-.774l.074-.004h5.586l-.875-1.43a.781.781 0 01.192-1.03l.061-.041a.77.77 0 011.023.192z" />
                      </svg>
                    </Link>
                    <Link to="/withdraw">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                        className="w-[20px] h-[20px] cursor-pointer ms-[8px] LQ0SY86vPLw0EJmAtKlQ"
                      >
                        <path d="M12.2 2.25A9.75 9.75 0 1021.95 12a9.76 9.76 0 00-9.75-9.75zm0 18A8.25 8.25 0 1120.45 12a8.26 8.26 0 01-8.25 8.25zm3.53-8.03a.747.747 0 010 1.06l-3 3a.747.747 0 01-1.061 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72V8.25a.75.75 0 111.5 0v5.69l1.72-1.72a.75.75 0 011.06 0z" />
                      </svg>
                    </Link>
                  </div>
                </div>
                <div className="akJFZv3131HI9dr7iFsJ" />
              </div>
            </div>

            {
              <div className="overflow-auto py-4">
                <div className="grid gap-2 items-center grid-cols-5">
                  {appGlobal?.PACKAGE?.map((i: any, index: number) => (
                    <div
                      onClick={() => setPackageId(i?._id)}
                      className={clsx(
                        " w-full h-[70px]  flex flex-col items-center justify-center rounded-md cursor-pointer shadow-md",
                        {
                          "bg-[#5bd690]": isTypeSwap === "buy",
                          "bg-[#f1493f]": isTypeSwap === "sell",
                          "border-[2px] border-[#fff]": packageId === i?._id,
                        }
                      )}
                    >
                      <div>{i?.time}</div>
                      <div>{i?.value}%</div>
                    </div>
                  ))}
                </div>
              </div>
            }

            <div className="trade-val-input mb-[12px]">
              <div className="">
                <span className="bit-input-affix-wrapper bit-input-affix-wrapper-lg bit-input-affix-wrapper-round bit-input-affix-wrapper-grey css-1qohw99">
                  <span className="bit-input-prefix">
                    <span>{t("Khối lượng")}</span>
                  </span>
                  <input
                    placeholder=""
                    className="bit-input bit-input-lg bit-input-round bit-input-grey css-1qohw99"
                    type="text"
                    defaultValue=""
                    value={formData}
                    onChange={(e) => {
                      const newValue = parseFloat(e.target.value.toString().replace(/,/g, "")) || 0;
                      setFormData(newValue);
                    }}
                    style={{ textAlign: "right" }}
                  />
                  <span className="bit-input-suffix">
                    <span>USDT</span>
                  </span>
                </span>
              </div>
            </div>

            <Slider
              tooltip={{ formatter: null }}
              marks={marks}
              onChange={handleChangeSlider}
            />

            <div className="tif mb-[24px]">
              <div className="qwOTRglv8obMUZfl2RJK">
                <div className="bit-dropdown-trigger KYl5LY4YtXFKwaQW6Vz9">
                  <p className="xKYX1qLRyNG9vc8qesdx">{t("Phí")}</p>
                  <span className="text-contentPrimary">
                    {appGlobal?.FEE_TRADING?.value}%
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    className="h-[16px] w-[16px]"
                  >
                    <path d="M15.384 10.448c.302-.405-.022-.948-.567-.948H9.183c-.545 0-.87.543-.567.948l2.817 3.78c.27.363.864.363 1.134 0l2.817-3.78z" />
                  </svg>
                </div>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div className="YVTNuiDUY61iuL7cdQPK">
              {user ? (
                <button
                  className={clsx(
                    "w-full rounded-[9999px] text-[#fff] min-h-[55px]  ",
                    {
                      "bg-[#5bd690]": isTypeSwap === "buy",
                      "bg-[#f1493f]": isTypeSwap === "sell",
                    }
                  )}
                  disabled={loading}
                  onClick={handleBuyToken}
                >
                  {isTypeSwap === "buy" ? t("Mua") : t("Bán")}
                </button>
              ) : (
                <Link to="/login" className="cursor-pointer">
                  <button
                    className={clsx(
                      "w-full rounded-[9999px] text-[#fff] min-h-[55px]  ",
                      {
                        "bg-[#5bd690]": isTypeSwap === "buy",
                        "bg-[#f1493f]": isTypeSwap === "sell",
                      }
                    )}
                  >
                    {t("Đăng nhập")}
                  </button>
                </Link>
              )}
            </div>
            <div className="tXVnHCksWj6rpybuBffV">
              <div className="_3spR1sRFPRlAUd_tCgf" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwapCoinFutrue;
